module.exports = __webpack_public_path__ + "img/top_cir.1f716287.png";